<template>
  <div>
    <v-card class="sf-card"
            flat>
      <div class="sf-card__header">
        <h2 class="sf-card__title">{{ $t('supplier') }}</h2>
      </div>
      <v-card-text class="sf-card__body">
        <v-form ref="form">
          <v-row class="sf-form-row">
            <v-col cols="12" sm="4">
              <v-text-field dense hide-details="auto"
                            outlined
                            v-bind:disabled="editMode"
                            v-bind:label="$t('supplierNumber')"
                            v-bind:rules="[ rules.required ]"
                            v-model="supplier.id" />
            </v-col>
            <v-col cols="12" sm="8">
              <v-text-field dense hide-details="auto"
                            outlined
                            v-bind:label="$t('companyName')"
                            v-bind:rules="[ rules.required ]"
                            v-model="supplier.companyName" />
            </v-col>
            <v-col cols="12">
              <v-text-field dense hide-details="auto"
                            outlined
                            v-bind:label="$t('friendlyName')"
                            v-bind:rules="[ rules.required ]"
                            v-model="supplier.supplierGroup" />
            </v-col>
          </v-row>

          <h3 class="sf-section-title mt-6">{{ $t('contact') }}</h3>
          <v-row class="sf-form-row">
            <v-col cols="12" sm="4">
              <v-text-field dense hide-details="auto"
                            outlined
                            v-bind:label="$t('salutation')"
                            v-model="supplier.salutation" />
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field dense hide-details="auto"
                            outlined
                            v-bind:label="$t('givenName')"
                            v-model="supplier.givenName" />
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field dense hide-details="auto"
                            outlined
                            v-bind:label="$t('familyName')"
                            v-model="supplier.familyName" />
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field dense hide-details="auto"
                            outlined
                            v-bind:label="$t('email')"
                            v-bind:rules="[ rules.required ]"
                            v-model="supplier.email" />
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field dense hide-details="auto"
                            outlined
                            v-bind:label="$t('web')"
                            v-model="supplier.web" />
            </v-col>
          </v-row>

          <h3 class="sf-section-title mt-6">{{ $t('address') }}</h3>
          <v-row class="sf-form-row">
            <v-col cols="12">
              <v-text-field dense hide-details="auto"
                            outlined
                            v-bind:label="$t('streetAddress')"
                            v-model="supplier.streetAddress" />
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field dense hide-details="auto"
                            outlined
                            v-bind:label="$t('postalCode')"
                            v-model="supplier.postalCode" />
            </v-col>
            <v-col cols="12" sm="8">
              <v-text-field dense hide-details="auto"
                            outlined
                            v-bind:label="$t('city')"
                            v-model="supplier.city" />
            </v-col>
          </v-row>

          <h3 class="sf-section-title mt-6">{{ $t('fair') }}</h3>
          <v-row class="sf-form-row">
            <v-col cols="12" sm="8">
              <v-autocomplete chips
                              deletable-chips
                              dense
                              hide-details="auto"
                              item-text="text"
                              item-value="number"
                              multiple
                              outlined
                              small-chips
                              v-bind:hint="boothHint"
                              v-bind:items="boothItems"
                              v-bind:label="$t('boothNumber')"
                              v-bind:persistent-hint="boothHint != null"
                              v-model="boothNumbers">
                <template v-slot:selection="{ item, selected }">
                  <v-chip close
                          small
                          v-bind:color="item.unknown ? 'warning' : (boothConflicts[item.number] != null ? 'error' : undefined)"
                          v-bind:input-value="selected"
                          v-bind:outlined="!item.unknown && boothConflicts[item.number] == null"
                          v-on:click:close="removeBooth(item.number)">
                    {{ item.text }}
                  </v-chip>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
          <!--<v-textarea dense hide-details="auto"
                      label="Description"
                      outlined
                      v-model="supplier.description" />-->

          <h3 class="sf-section-title mt-6">{{ $t('delivery') }}</h3>
          <v-row class="sf-form-row">
            <v-col cols="12" sm="6">
              <v-text-field dense hide-details="auto"
                            outlined
                            v-bind:label="$t('deliveryPeriod0Tag')"
                            v-model="supplier.deliveryPeriod0Tag" />
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field dense hide-details="auto"
                            outlined
                            v-bind:label="$t('deliveryPeriod1Tag')"
                            v-model="supplier.deliveryPeriod1Tag" />
            </v-col>
          </v-row>

          <h3 class="sf-section-title mt-6">{{ $t('registrationDetails') }}</h3>
          <v-row class="sf-form-row">
            <v-col cols="12" sm="6">
              <v-text-field dense hide-details="auto"
                            outlined
                            v-bind:label="$t('countBoothStaff')"
                            v-model="supplier.countBoothStaff" />
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field dense hide-details="auto"
                            outlined
                            v-bind:label="$t('countTables')"
                            v-model="supplier.countTables" />
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field dense hide-details="auto"
                            outlined
                            v-bind:label="$t('countRegularOutlets')"
                            v-model="supplier.countRegularOutlets" />
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field dense hide-details="auto"
                            outlined
                            v-bind:label="$t('countSpecialOutlets')"
                            v-model="supplier.countSpecialOutlets" />
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field dense hide-details="auto"
                            outlined
                            v-bind:label="$t('countDinnerAttendees')"
                            v-model="supplier.countDinnerAttendees" />
            </v-col>
            <v-col cols="12">
              <v-textarea dense hide-details="auto"
                          outlined
                          v-bind:label="$t('comments')"
                          v-model="supplier.comments" />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
  import plan from '@/assets/floorplan.json'
  import { formatBoothNumbers, parseBoothNumbers, planNumbers, supplierDisplayName } from '@/lib/floorplan/booths'

  export default {
    computed: {
      /**
       * Nummern anderer Lieferanten, die mit den hier gewählten kollidieren: Nummer → Lieferantenname.
       */
      boothConflicts() {
        const conflicts = {}
        const mine = new Set(this.boothNumbers)

        for (const other of this.$store.getters.suppliers || []) {
          if (this.supplier == null || other.id === this.supplier.id) {
            continue
          }

          for (const number of parseBoothNumbers(other.boothNumber)) {
            if (mine.has(number)) {
              conflicts[number] = supplierDisplayName(other)
            }
          }
        }

        return conflicts
      },
      boothHint() {
        const entries = Object.entries(this.boothConflicts)

        if (entries.length === 0) {
          return null
        }

        return this.$t('boothConflict', { list: entries.map(([number, name]) => `${number} (${name})`).join(', ') })
      },
      boothItems() {
        const items = planNumbers(plan).map(item => ({
          number: item.number,
          text: item.label != null ? `${item.number} · ${item.label}` : item.number,
          unknown: false
        }))
        const known = new Set(items.map(i => i.number))

        for (const number of this.boothNumbers) {
          if (!known.has(number)) {
            items.push({ number, text: `${number} (${this.$t('notOnPlan')})`, unknown: true })
          }
        }

        return items
      },
      boothNumbers: {
        get() {
          return parseBoothNumbers(this.supplier != null ? this.supplier.boothNumber : null)
        },
        set(numbers) {
          this.supplier.boothNumber = numbers.length > 0 ? formatBoothNumbers(numbers) : null
        }
      },
      rules() {
        return {
          required: v => !!v || this.$t('form.required')
        }
      }
    },
    methods: {
      removeBooth(number) {
        this.boothNumbers = this.boothNumbers.filter(n => n !== number)
      },
      validate() {
        return this.$refs.form.validate()
      }
    },
    name: 'SupplierEditCard',
    props: {
      editMode: Boolean,
      supplier: Object
    }
  }
</script>

<i18n>
  {
    "de": {
      "city": "Stadt",
      "companyName": "Firmenname",
      "email": "E-Mail-Adresse",
      "givenName": "Vorname",
      "familyName": "Nachname",
      "friendlyName": "Anzeigename",
      "postalCode": "Postleitzahl",
      "streetAddress": "Adresse",
      "salutation": "Anrede",
      "supplier": "Lieferant",
      "supplierNumber": "Lieferantennummer",
      "web": "Website",
      "registrationDetails": "Anmeldeinformationen",
      "countBoothStaff": "Anzahl der Standmitarbeiter",
      "countTables": "Menge Biertischgarnituren",
      "countRegularOutlets": "Menge an Steckdosen Haushaltsstrom",
      "countSpecialOutlets": "Menge an Steckdosen Starkstrom",
      "countDinnerAttendees": "Teilnahme am gemeinsamen Abendessen/Personenanzahl",
      "comments": "Weitere Anmerkungen",
      "delivery": "Lieferung",
      "deliveryPeriod0Tag": "Lieferzeitraum 1",
      "deliveryPeriod1Tag": "Lieferzeitraum 2",
      "boothNumber": "Standnummer",
      "boothConflict": "Bereits bei anderen Lieferanten vergeben: {list}",
      "notOnPlan": "nicht im Plan",
      "contact": "Kontakt",
      "address": "Adresse",
      "fair": "Messe"
    },
    "en": {
      "city": "City",
      "companyName": "Company name",
      "email": "Email",
      "givenName": "Given name",
      "familyName": "Family name",
      "friendlyName": "Anzeigename",
      "postalCode": "Postal code",
      "streetAddress": "Street address",
      "salutation": "Salutation",
      "supplier": "Supplier",
      "supplierNumber": "Supplier number",
      "web": "Web",
      "registrationDetails": "Registration details",
      "countBoothStaff": "Count booth staff",
      "countTables": "Count tables",
      "countRegularOutlets": "Count regular outlets",
      "countSpecialOutlets": "Count special outlets",
      "countDinnerAttendees": "Count dinner attendees",
      "comments": "Comments",
      "delivery": "Delivery",
      "deliveryPeriod0Tag": "Delivery period 1",
      "deliveryPeriod1Tag": "Delivery period 2",
      "boothNumber": "Booth number",
      "boothConflict": "Already assigned to other suppliers: {list}",
      "notOnPlan": "not on plan",
      "contact": "Contact",
      "address": "Address",
      "fair": "Fair"
    }
  }
</i18n>